import { useState, useEffect } from "react";
import { Container, Table } from "react-bootstrap";
import { CSVLink } from "react-csv";

export default function ListTeachers(props) {
  const ls = require("localstorage-ttl");
  const [data, setData] = useState([]);

  useEffect(() => {
    LoadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const LoadData = () => {
    const dataCache = JSON.parse(ls.get("teachers"));
    let teachers = [];
    for (let i = 0; i < dataCache.length; i++) {
      const u = dataCache[i];
      let x = {
        id: u.id,
        nombre: u.attributes.name,
        docNumber: u.attributes.docNumber,
        maxgradeId: u.attributes.maxgrade?.data?.id,
        maxgrade: u.attributes.maxgrade?.data?.attributes.name,
        userId: u.attributes.user?.data?.id,
      };
      teachers.push(x);
    }
    setData(teachers);
  };

  return (
    <Container className="p-3 mb-4 bg-light rounded-3">
      <h4>EXPORTAR EXAMINADORES</h4>
      <CSVLink
        data={data}
        filename={"faa-examinadores.csv"}
        className="btn btn-success btn-sm"
      >
        DESCARGAR
      </CSVLink>
      <Table striped hover size="sm" responsive="sm">
        <thead>
          <tr>
            <th>#</th>
            <th>ID</th>
            <th>DNI</th>
            <th>Nombre</th>
            <th>Max.Grade</th>
            <th>User ID</th>
          </tr>
        </thead>
        <tbody>
          {!data || data.length < 1 ? (
            <tr>
              <td colSpan="6" align="center">
                No hay datos.
              </td>
            </tr>
          ) : (
            data.map((u, index) => (
              <tr key={index}>
                <td align="center">{++index}</td>
                <td align="center">{u.id}</td>
                <td align="center">{u.docNumber}</td>
                <td align="left">{u.nombre}</td>
                <td align="center">{u.maxgrade}</td>
                <td align="center">{u.userId}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </Container>
  );
}
